import { render, staticRenderFns } from "./ConfirmationAlert.vue?vue&type=template&id=3939606e&scoped=true"
import script from "./ConfirmationAlert.vue?vue&type=script&lang=js"
export * from "./ConfirmationAlert.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationAlert.vue?vue&type=style&index=0&id=3939606e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3939606e",
  null
  
)

export default component.exports